import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/shared/ui';
import { DefaultPointsCard } from './DefaultPointsCard';
import { SatisfactionLevelsCard } from './SatisfactionLevelsCard';

export interface KpiSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const KpiSettingsDialog: React.FC<KpiSettingsDialogProps> = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent style={{ maxWidth: 640 }}>
      <DialogTitle>Настройки KPI</DialogTitle>
      <DialogDescription>
        Величины применяются к начислениям после сохранения. Уже начисленные очки не
        пересчитываются.
      </DialogDescription>
      <SatisfactionLevelsCard />
      <DefaultPointsCard />
    </DialogContent>
  </Dialog>
);
